
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return require("private-next-pages/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup"])
      });
    }
  